/**
 * Route path constants for the standalone Operator panel ({@link OperatorComponent}, #205). Mirrors
 * {@link EmployeePanelRoutes} — one file the sidebar and the routes table both read from.
 */
export enum OperatorPanelRoutes {
  /** The live open-tables overview ({@link OpenTablesComponent}, workstream C) — currently the panel's only screen. */
  OpenTables = '',

  // Future: the kitchen screen ("Küche" — a McDonald's-style "what to cook next" view, #205 decision). It is
  // the whole reason Operator gets its own panel instead of a single route: the next live-service screen slots
  // in here as one more route, not a new role. Not built yet — see the sidebar's disabled placeholder entry in
  // operator.component.html.
  // Kitchen = 'kitchen',
}
